import {
  ApiBlueprint,
  configApiRef,
  createFrontendModule,
  gitlabAuthApiRef,
} from '@backstage/frontend-plugin-api';
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmAuthApiRef,
} from '@backstage/integration-react';

/**
 * `scmAuthApiRef` for our self-hosted GitLab.
 *
 * The default one (`api:app/scm-auth`, from `@backstage/plugin-app`) is
 * `ScmAuth.createDefaultApiFactory()`, which knows GitLab only at `gitlab.com`.
 * For `git.uzum.io` its `getCredentials` finds no provider, and RepoUrlPicker's
 * `requestUserCredentials` — the go-service template's way of creating the
 * project with the user's own token — fails. Same `pluginId` and `name`, so
 * this replaces the default extension rather than adding a second one.
 *
 * The hosts come from `integrations.gitlab` rather than a literal, so a URL the
 * catalog can read and a URL a template can publish to never drift apart. The
 * `gitlab-auth` API behind it is the default one; it already reads
 * `auth.environment` and talks to `auth.providers.gitlab`, which is token-only
 * — sign-in stays Google.
 */
const scmAuthApi = ApiBlueprint.make({
  name: 'scm-auth',
  params: defineParams =>
    defineParams({
      api: scmAuthApiRef,
      deps: { gitlab: gitlabAuthApiRef, configApi: configApiRef },
      factory: ({ gitlab, configApi }) =>
        ScmAuth.merge(
          ...ScmIntegrationsApi.fromConfig(configApi)
            .gitlab.list()
            .map(integration =>
              ScmAuth.forGitlab(gitlab, { host: integration.config.host }),
            ),
        ),
    }),
});

export const scmAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [scmAuthApi],
});
